<app-pagetitle title="{{nameApp}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right"
                        *hasPermission="{app: constant.ELEMENTOS_NIVELES_PERMISOS, permission: [constant.CREAR, constant.CREAR]}">
                        <button type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i>
                            Nuevo</button>
                    </div>
                </div>
            </div>
            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                    class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nivel-Aplicación</th>
                            <th>Ambiente-Riesgo</th>
                            <th>Ambiente-Indicador</th>
                            <th>Fecha incio</th>
                            <th>Fecha fin</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let row of dataMapeadaElementosNivelesPermisos ;let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{ row.nombreNivel}} -{{
                                row.nombreAplicacion}}</td>
                            <td>{{ row.ambienteRiesgo}}</td>
                            <td>{{ row.ambienteIndicador}}</td>
                            <td>{{ row.fechaInicio | date: 'dd-MM-yyyy'}}</td>
                            <td>{{ row.fechaFin | date: 'dd-MM-yyyy'}}</td>
                            <td>{{ row.estado == "1" ? "Activo" : "Inactivo"
                                }}</td>
                            <td class="text-center">
                                <div class="row"
                                    *hasPermission="{app: constant.ELEMENTOS_NIVELES_PERMISOS, permission: [constant.CREAR, constant.CREAR]}">
                                    <button type="button" tooltip="Editar"
                                        class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                        title="Editar este registro" (click)="edit(row)">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button type="button" class="btn btn-sm btn-link waves-effect col px-0"
                                        title="Eliminar este registro" (click)="delete(row.idSprElementoNivelPermiso)">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete-permisos" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>


<jw-modal id="{{nameModal}}">
    <div class="modal-dialog modal-xl modal-dialog-scrollable " style="padding-top:5% ">
        <div class="modal-content ">
            <div class="modal-header pb-3 ">

                <button type="button " class="btn-close " (click)="closeModalPerm(); " aria-label="Close "></button>
            </div>

            <div class="modal-body px-5 ">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button class="nav-link active" id="permisosNiveles-tab" data-bs-toggle="tab"
                            data-bs-target="#permisosNiveles" type="button" role="tab" aria-controls="permisosNiveles"
                            aria-selected="true ">Permisos Niveles
                        </button>
                        <button class="nav-link" id="permisosElementos-tab" data-bs-toggle="tab"
                            data-bs-target="#permisosElementos " type="button" role="tab"
                            aria-controls="permisosElementos" aria-selected="false ">Permisos Elementos</button>
                    </div>
                </nav>

                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="permisosNiveles" role="tabpanel "
                        aria-labelledby="permisosNiveles-tab ">
                        <h6 *ngIf="activaPermElementos==true && permElemento == true ">Permiso activo por Elementos.
                        </h6>
                        <form class="needs-validation" novalidate id="formPermiso" [formGroup]="formPermiso">
                            <input type="hidden" formControlName="idSprElementoNivelPermiso"
                                [value]="idSprElementoNivelPermiso">
                            <div *ngIf="activaPermNiveles == true" class="row">

                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprNivel"
                                            class=" form-control-label text-md-right pt-1 "><b>Niveles:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select (change)="changeNivelSelected($event)" class="form-select"
                                            id="idSprNivel" formControlName="idSprNivel">
                                            <option *ngFor="let row of dataNiveles" value={{row.idSprComun}}>
                                                {{row.descripcion}} -
                                                [{{row.nombre}}]
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprAplicacion"
                                            class=" form-control-label text-md-right pt-1 "><b>Aplicación:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select class="form-select col-12" id="idSprAplicacion"
                                            (change)="changeVerificaRepetidosNivelesElementos($event)"
                                            formControlName="idSprAplicacion">
                                            <option *ngFor="let tipo of dataAplicaciones"
                                                value={{tipo.idSprAplicacion}}>
                                                {{tipo.nombre}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="fechaInicio" class="form-control-label text-md-right pt-1"><b>Fecha
                                                inicio:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <input type="date" class="form-control" required="true"
                                            placeholder="fechaInicio" formControlName="fechaInicio"
                                            [ngClass]="{'is-invalid': this.formPermiso.get('fechaInicio')?.errors && this.formSubmitted,'is-valid': !this.formPermiso.get('fechaInicio')?.errors, }" />
                                        <div class="col text-danger">
                                            <span class="font-italic"
                                                *ngIf="this.formPermiso.get('fechaInicio')?.errors?.['required'] && this.formSubmitted">Campo
                                                requerido</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="fechaFin" class="form-control-label text-md-right pt-1"><b>Fecha
                                                fin:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <input type="date" class="form-control" required="true" placeholder="fechaFin"
                                            formControlName="fechaFin"
                                            [ngClass]="{'is-invalid': this.formPermiso.get('fechaFin')?.errors && this.formSubmitted,'is-valid': !this.formPermiso.get('fechaFin')?.errors, }" />
                                        <div class="col text-danger">
                                            <span class="font-italic"
                                                *ngIf="this.formPermiso.get('fechaFin')?.errors?.['required'] && this.formSubmitted">Campo
                                                requerido</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="col text-danger">
                                            <span *ngIf="this.formPermiso?.errors">
                                                {{formPermiso.errors.mensaje}}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="comentario"
                                            class=" form-control-label text-md-right"><b>Comentario:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <textarea class="form-control" row="6" maxlength="500" id="comentario"
                                            placeholder="Ingrese comentario/descripción"
                                            formControlName="comentario"></textarea>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <div class="col col-md-3 text-md-right ">
                                        <label for="estado "
                                            class="col-form-label text-md-right "><b>Estado:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select id="estado" class="form-select" formControlName="estado" required="true"
                                            [ngClass]="{ 'is-invalid': this.formPermiso.get('estado')?.errors && this.formSubmitted, 'is-valid': !this.formPermiso.get('estado')?.errors, } ">
                                            <option value="1" selected>Activo</option>
                                            <option value="2">Inactivo</option>
                                        </select>
                                        <div class="col text-danger ">
                                            <span class="font-italic "
                                                *ngIf="this.formPermiso.get( 'estado')?.errors?.[ 'required'] && this.formSubmitted ">Campo
                                                requerido</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button " class="btn btn-info " (click)="onSubmit() ">Guardar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="tab-pane fade" id="permisosElementos" role="tabpanel"
                        aria-labelledby="permisosElementos-tab">
                        <h6 *ngIf="activaPermNiveles == true && permNivel == true">Permiso activo por Niveles.</h6>
                        <form class="needs-validation" novalidate id="formPermisoElementos"
                            [formGroup]="formPermisoElementos">
                            <input type="hidden" formControlName="idSprElementoNivelPermiso"
                                [value]="idSprElementoNivelPermiso">                                
                            <div *ngIf="activaPermElementos==true" class="row">
                                
                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprNivel"
                                            class=" form-control-label text-md-right pt-1 "><b>Nivel:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select class="form-select col-12" id="idSprNivel" formControlName="idSprNivel"
                                            (change)="changeNivel($event)">
                                            <option *ngFor="let row of dataNiveles" value={{row.idSprComun}}>
                                                [{{row.nombre}}] -
                                                {{row.descripcion}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprAmbiente"
                                            class=" form-control-label text-md-right pt-1 "><b>Ambientes:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select class="form-select col-12" id="idSprAmbiente"
                                            formControlName="idSprAmbiente" (change)="changeSelectedAmbiente($event)">
                                            <option *ngFor="let tipo of dataAmbientesNiveles"
                                                value={{tipo.idSprAmbiente}}>
                                                [{{tipo.nombreCorto}}] -
                                                {{tipo.nombreUnidad}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprAplicacion"
                                            class=" form-control-label text-md-right pt-1 "><b>Aplicación:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select class="form-select col-12" id="idSprAplicacion"
                                            formControlName="idSprAplicacion" (change)="changeRiesgoIndicador($event)">
                                            <option *ngFor="let tipo of dataIndicadoresRiesgos"
                                                value={{tipo.idSprAplicacion}}>
                                                {{tipo.nombre}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprAmbienteRiesgoIndicador"
                                            class=" form-control-label text-md-right pt-1 "><b>Elemento:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select class="form-select col-12" id="idSprAmbienteRiesgoIndicador"
                                            formControlName="idSprAmbienteRiesgoIndicador"
                                            (change)="changeElemento($event)">
                                            <option *ngFor="let tipo of dataElementosStatic" value={{tipo.value}}>
                                                {{tipo.label}}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div *ngIf="activarFormEditar==true" class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="idSprELemento"
                                            class=" form-control-label text-md-right pt-1 "><b>Indicador/Riesgo:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">

                                        <select class="form-select col-12" id="idSprELemento"
                                            formControlName="idSprELemento" (change)="changeIdSelectedElement($event)">
                                            <option *ngFor="let row of dataIndicadorRiesgo"
                                                value={{row.idSprRiesgo}}*{{row.idSprIndicador}}>
                                                {{(row.idSprIndicador)?
                                                row.idSprIndicador :
                                                row.idSprRiesgo}} -
                                                {{row.nombre}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            

                                <div class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="fechaInicio" class="form-control-label text-md-right pt-1"><b>Fecha
                                                inicio:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <input type="date" class="form-control" required="true"
                                            placeholder="fechaInicio" formControlName="fechaInicio"
                                            [ngClass]="{'is-invalid': this.formPermisoElementos.get('fechaInicio')?.errors && this.formSubmitted,'is-valid': !this.formPermisoElementos.get('fechaInicio')?.errors, }" />
                                        <div class="col text-danger">
                                            <span class="font-italic"
                                                *ngIf="this.formPermisoElementos.get('fechaInicio')?.errors?.['required'] && this.formSubmitted">Campo
                                                requerido</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-3">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="fechaFin" class="form-control-label text-md-right pt-1"><b>Fecha
                                                fin:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <input type="date" class="form-control" required="true" placeholder="fechaFin"
                                            formControlName="fechaFin"
                                            [ngClass]="{'is-invalid': this.formPermisoElementos.get('fechaFin')?.errors && this.formSubmitted,'is-valid': !this.formPermisoElementos.get('fechaFin')?.errors, }" />
                                        <div class="col text-danger">
                                            <span class="font-italic"
                                                *ngIf="this.formPermisoElementos.get('fechaFin')?.errors?.['required'] && this.formSubmitted">Campo
                                                requerido</span>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <div class="col text-danger">
                                            <span *ngIf="this.formPermisoElementos?.errors">
                                                {{formPermisoElementos.errors.mensaje}}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <div class="col col-md-3 text-md-right">
                                        <label for="comentario"
                                            class=" form-control-label text-md-right"><b>Comentario:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <textarea class="form-control" row="6" maxlength="500" id="comentario"
                                            placeholder="Ingrese comentario/descripción"
                                            formControlName="comentario"></textarea>
                                    </div>
                                </div>

                                <div class="form-group row mb-2">
                                    <div class="col col-md-3 text-md-right ">
                                        <label for="estado "
                                            class="col-form-label text-md-right "><b>Estado:</b></label>
                                    </div>
                                    <div class="col-12 col-md-9">
                                        <select id="estado" class="form-select" formControlName="estado" required="true"
                                            [ngClass]="{ 'is-invalid': this.formPermisoElementos.get('estado')?.errors && this.formSubmitted, 'is-valid': !this.formPermisoElementos.get('estado')?.errors, } ">
                                            <option value="1" selected>Activo</option>
                                            <option value="2">Inactivo</option>
                                        </select>
                                        <div class="col text-danger ">
                                            <span class="font-italic "
                                                *ngIf="this.formPermisoElementos.get( 'estado')?.errors?.[ 'required'] && this.formSubmitted ">Campo
                                                requerido</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button " class="btn btn-info "
                                        (click)="onSubmitElementos() ">Guardar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button " class="btn btn-secondary waves-effect"
                    (click)="closeModalPerm(); ">Cerrar</button>
                <!--   <button type="button " class="btn btn-info " (click)="onSubmit() ">Guardar</button> -->
            </div>
        </div>
    </div>
</jw-modal>